export const apiPaths={
   'FETCH_PRODUCTS':'/data',
   'UPDATE_PRODUCT_STATUS':'/data'
}